import React, { PureComponent } from 'react';
import { SectionTypeInitialText, TypeSection } from '../../components/type-of-sections';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, REDUCER_NAME } from '../../redux/modules/service-detail';

class ServiceDetails extends PureComponent {

  componentWillMount() {
    const { match: { params: { serviceId } } } = this.props;
    if (serviceId) {
      this.props.getAction(serviceId);
    }
  }

  render() {
    const { servicesDetail: { values, isFetching } } = this.props;

    if (isFetching) {
      return <div/>;
    }

    if (Object.keys(values).length === 0) {
      return (<div className="row">
        <div className="main container event-detail">
          <div className="row">
            <div className="col-md-12 event-detail__section">
              <h4>A página pelo qual procura não esta disponivel</h4>
            </div>
          </div>
        </div>
      </div>);
    }

    return (
      <div>
        <div className="main container event-detail">
          <div className="event-detail__section">
            <SectionTypeInitialText showImages={false} showDates={false} {...values}/>
          </div>
          <TypeSection values={values}/>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      [REDUCER_NAME]: state[REDUCER_NAME]
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(ServiceDetails);



// WEBPACK FOOTER //
// ./src/containers/service-details/ServiceDetails.js